import React, {useEffect} from "react";
import {Navigate, useLocation} from "react-router-dom";
import {useAuthStore} from "@store/AuthStore";
import {AppRoute} from "@router/RoutingModels";
import {buildRoute} from "@router/RouterUtils";
import {useShallow} from "zustand/react/shallow";

export default function ProtectedRoute({children}: { children: React.ReactNode }) {

    const {
        loading,
        isAuthenticated,
        isLoggingOut,
        postLoginRedirectPath,
        setPostLoginRedirect
    } = useAuthStore(useShallow(s => ({
        loading: s.loading,
        isAuthenticated: s.isAuthenticated,
        isLoggingOut: s.isLoggingOut,
        postLoginRedirectPath: s.postLoginRedirectPath,
        setPostLoginRedirect: s.setPostLoginRedirect,
    })));

    const location = useLocation();

    useEffect(() => {
        console.log("[ProtectedRoute]", isAuthenticated)

        if (loading || isAuthenticated) return;
        const target = location.pathname + location.search + location.hash;
        if (postLoginRedirectPath !== target) {
            setPostLoginRedirect(target);
        }
    }, [loading, isAuthenticated, location.pathname, location.search, location.hash, postLoginRedirectPath, setPostLoginRedirect]);

    if (loading || isLoggingOut) return null;

    if (!isAuthenticated) {
        console.log("Protected route, not authenticated, redirecting to ", postLoginRedirectPath || "welcome")
        return <Navigate to={buildRoute(AppRoute.WELCOME)} replace/>;
    }

    return <>{children}</>;
}